/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { ViewComponent } from './view';
export * from './view-constants';
export * from './view';
export function defineViewComponent() {
    defineCustomElement(ViewComponent);
}
